module.exports = __webpack_public_path__ + "static/media/xxJy.7926fb61.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xxJy.png
// module id = 1874
// module chunks = 0 1